import { t } from "@/i18n-js/instance";

import { LineItem } from "./LineItem";

interface CurrentPlanCreditProps {
  currentPlanCredit: string;
}

export const CurrentPlanCredit = ({
  currentPlanCredit,
}: CurrentPlanCreditProps) => (
  <LineItem
    description={t(
      "pricing_plans.plan_settings.plan_summary.current_plan_credit",
    )}
    value={currentPlanCredit}
    valueProps={{ color: "text-green-success" }}
  />
);
